export const SAVE_ALLOCATION_QUERY = `
  mutation (
    $accountId: String!,
    $accountType: String!,
    $allocationYear: Int!,
    $startDate: String!,
    $reference: String,
    $allocations: [AccountMappingBreakdown]
  ) {
    createAccountMapping(
      accountMapping: {
        accountId: $accountId,
        accountType: $accountType,
        allocationYear: $allocationYear,
        startDate: $startDate,
        reference: $reference,
        allocations: $allocations
      }
    ) {
      error {
        code
        message
        statusCode
      }
      data {
        accountId
        id
        mappings {
          startDate
          accountType
          endDate
          reference
          insertedDate
          allocations {
            element1Id
            element2Id
            element3Id
            element4Id
            percentage
          }
        }
      }
    }
  }
`
